import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import userStore from '../../../store/userStore';

/**
 * El admin trabaja lo que entra al buzón de ClaimUp (recobro) y puede mirar lo
 * de los dominios de AR de los clientes, que asignan ellos. La empresa y sus
 * gestores solo ven lo suyo, así que a ellos no se les ofrece el selector:
 * enseñar un desplegable con una sola opción posible sugiere que hay más.
 */
export const PHASE_OPTIONS = [
  { value: 'recovery', label: 'Recobro' },
  { value: 'ar', label: 'AR (de los clientes)' },
  { value: 'all', label: 'Todos' },
];

const UnmatchedEmailFilters = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { user } = userStore();
  const isAdmin = user?.role === 'admin';
  const currentPhase = searchParams.get('phase') || 'recovery';

  const handlePhaseChange = phase => {
    const newParams = new URLSearchParams(searchParams);
    if (phase === 'recovery') newParams.delete('phase');
    else newParams.set('phase', phase);
    newParams.delete('page');
    setSearchParams(newParams);
  };

  const currentStatus = searchParams.get('status') || 'pending';
  const currentSearch = searchParams.get('search') || '';

  const handleStatusChange = status => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set('status', status);
    newParams.delete('page');
    setSearchParams(newParams);
  };

  const handleSearchChange = e => {
    const value = e.target.value;
    const newParams = new URLSearchParams(searchParams);
    if (value) {
      newParams.set('search', value);
    } else {
      newParams.delete('search');
    }
    newParams.delete('page');
    setSearchParams(newParams);
  };

  const statusOptions = [
    { value: 'pending', label: 'Pendientes' },
    { value: 'assigned', label: 'Asignados' },
    { value: 'ignored', label: 'Ignorados' },
    { value: 'all', label: 'Todos' },
  ];

  return (
    <div className='flex flex-wrap items-center gap-4'>
      {isAdmin && (
        <label className='flex items-center gap-2 text-sm text-gray-600'>
          Fase
          <select
            aria-label='Fase'
            value={currentPhase}
            onChange={e => handlePhaseChange(e.target.value)}
            className='rounded-lg border-gray-300 text-sm'
          >
            {PHASE_OPTIONS.map(o => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
        </label>
      )}
      {/* Status filter */}
      <div className='flex items-center gap-2'>
        {statusOptions.map(option => (
          <button
            key={option.value}
            onClick={() => handleStatusChange(option.value)}
            className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${
              currentStatus === option.value
                ? 'bg-blue-100 text-blue-700'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
          >
            {option.label}
          </button>
        ))}
      </div>

      {/* Search */}
      <div className='flex-1 max-w-md'>
        <div className='relative'>
          <MagnifyingGlassIcon className='absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400' />
          <input
            type='text'
            value={currentSearch}
            onChange={handleSearchChange}
            placeholder='Buscar por asunto, remitente...'
            className='w-full pl-9 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-blue-500'
          />
        </div>
      </div>
    </div>
  );
};

export default UnmatchedEmailFilters;
